// import {List, ListItem, Typography} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AppContext from "../../app/app_context";
//import { Languages } from "app/values/settings";
import styles from "../../assets/jss/weatherplus/layouts/authStyle.js";
//import Button from "../../components/CustomButtons/Button.js";
// import Footer from "../../components/Footer/Footer.js";
// import Header from "../../components/Header/Header.js";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { matchRoutes } from "react-router-config";
import { Link, useLocation } from "react-router-dom";
import i18n from "../../i18n";
// import MenuDesktop from "./components/MenuDesktop";
// import MenuMaterial from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import {isDesktop} from "react-device-detect";
// import TemperatureUnitSwitch from "../../components/TabHeader/UnitSwitch";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemText from "@mui/material/ListItemText";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import Collapse from "@mui/material/Collapse";
// import ListMaterial from "@mui/material/List";
// import GridContainer from "../../components/Grid/GridContainer";
// import GridItem from "../../components/Grid/GridItem";
// import Fade from "@mui/material/Fade";
// import reducer from "../pages/news/store/reducers"
// import withReducer from "../store/with_reducer";
import { useHistory } from "react-router-dom";
// import { getSolutionsData } from "app/services/weather";
// import LogoWeatherplus from "../../assets/img/weather_update/header/logo_weatherplus_new.jpg";
// import {ReactComponent as YoutubeIcon} from "../../assets/img/youtube_black.svg";
// import {ReactComponent as LinkedinIcon} from "../../assets/img/linkedin_black.svg";
// import {ReactComponent as FacebookIcon} from "../../assets/img/facebook_black.svg";
// import {ReactComponent as EnvelopeIcon} from "../../assets/img/envelope_black.svg";
// import logoApp2 from "assets/img/weather_update/header/logo_app_2.png"
// import ImageDownload from "assets/img/weather_update/header/download.png"
// import {getNews} from "../pages/news/store/actions";
// import ImageClose from "assets/img/weather_update/header/button-close-popup.png"
// import TickRed from "assets/img/weather_update/header/tick-red.svg"
// import IconDownload from "assets/img/weather_update/header/icon-download.svg"
// import QR_App from "assets/img/weather_update/header/QR_install_app.png"

const useStyles = makeStyles(styles);

const AuthLayout = (props) => {
  // const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const history = useHistory();
  const { routes } = appContext;
  const location = useLocation();
  const { pathname } = location;
  const matched = matchRoutes(routes, pathname)[0];

  let layout = {
    appBar: true,
    footer: false,
  };

  if (matched && matched.route.settings) {
    const routeSettings = matched.route.settings;
    if (routeSettings.layout) {
      layout = routeSettings.layout;
    }
  }

  const classes = useStyles();
  const wrapper = useRef();
  const language = useSelector(({ settings }) => settings.language);
  // const career = WeatherService.getSolutionsData();
  // const categories = carrer ? carrer.solutions : [];

  const { t } = useTranslation("common");

  // const [languageDialog, setLanguageDialog] = useState(false);

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language.toLowerCase());
    }
  }, [language]);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [mobileAboutOpen,setMobileAboutOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  // const [weatherCareerAnchorEl, setWeatherCareerAnchorEl] = useState(null);
  const [forecastAnchorEl,setForecastAnchorEl] = useState(null);
  const [aboutAnchorEl, setAboutAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openMenuWeather,setOpenMenuWeather] = useState(false)

  const [anchorNews, setAnchorNews] = useState(null)
  const [checkMenuNews,setCheckMenuNews] = useState(false)    

  // const [checkPopupApp,setCheckPopupApp] = useState(false)

  // const handleOpenPopup = () => {
  //   setCheckPopupApp(!checkPopupApp);
  // }
  // const handleAutoOpenPopup = () => {
  //     setCheckPopupApp(true)
  // }
  // useEffect(() => {
  //        const timeoutPopup = setTimeout(handleAutoOpenPopup,10000) ;
  //        return () => {
  //            clearTimeout(timeoutPopup);
  //        }
  // },[])
    // useEffect(() => {
    //     if (checkPopupApp) {
    //        const timeoutId = setTimeout(handleClosePopup,14000);
    //         return () => {
    //            clearTimeout(timeoutId)
    //         }
    //     }
    // },[checkPopupApp])
 // const handleClosePopup = () => {
 //    setCheckPopupApp(false);
 // }
 // const openPopupApp = Boolean(checkPopupApp);
 //  const idPopupApp = openPopupApp ? 'simple-popover' : undefined;

  const handleShowMenuNewsMobile = () =>{
    setCheckMenuNews(!checkMenuNews);
  };
  const handleShowMenuNewsDesktop = (event) => {
    setAnchorNews(event.currentTarget)
  };
  const handleCloseMenuNewsDesktop = () => {
    setAnchorNews(null)
  };
  const handleClickProductMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseProductMenu = () => {
    setAnchorEl(null);
  };
  const handleClickForecastMenu = (event) => {
    setForecastAnchorEl(event.currentTarget);
  };
  const handleCloseForecastMenu = () => {
    setForecastAnchorEl(null);
  };
  const handleClickAbout = (event) => {
    setAboutAnchorEl(event.currentTarget)
  }
  const handleCloseAbout = () => {
    setAboutAnchorEl(null)
  };
  const handleClickButton = () => {
    setMobileOpen(false);
  };

  const handleClickMenuWeatherMobi = () => { setOpenMenuWeather(!openMenuWeather)}

  const handleClickMenuMobile = () => {
    setOpenMenu(!openMenu);
  };
  const handleClickMenuAboutMobile = () =>{
    setMobileAboutOpen(!mobileAboutOpen)
  }
  const HandleCloseMenuMobileAbout = () => {
    setMobileAboutOpen(false)
  }

  const handleDataPastMobile = () => {
    history.push({ state: { isCheckMobile: true } });
    handleClickMenuMobile();
  };
  const pathName = window.location.pathname;

  return (
    <div>

      {/*<UserFormInput*/}
      {/*  isVisiableModal={isVisiableModal}*/}
      {/*  handleClickCloseModal={handleClickCloseModal}*/}
      {/*  width={12}*/}
      {/*/>*/}
      <div className={classes.wrapper} ref={wrapper}>

          <div className={classes.fullPage}>
            {props.children}
          </div>
      </div>
      {/* {layout.footer && <Footer />} */}
    </div>
  );
};

AuthLayout.displayName = "AuthLayout";

AuthLayout.propTypes = { children: PropTypes.node.isRequired };

// export default withReducer("news",reducer)(AuthLayout);

export default AuthLayout;
